module.exports = __webpack_public_path__ + "static/img/map5_relation.df6f59b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/map5_relation.jpg
// module id = /dnd
// module chunks = 1